import axios from "axios";
import { API } from '../API/api';
export const logOperation = async ({
  operation_type,
  entity_type,
  entity_id,
  description,
}) => {

  const storedAuthState = sessionStorage.getItem('authLocalstorage');
        const parsedAuthState = JSON.parse(storedAuthState);

     await axios.post(
      `${API}/operation-logs`,
      {
        operation_type,
        entity_type,
        entity_id,
        description,
        operation_date: new Date().toISOString().slice(0, 19).replace("T", " "), // Format: YYYY-MM-DD HH:mm:ss
      },
      {
        headers: {
          Authorization: `Bearer ${parsedAuthState.token}`, // or sessionStorage
          "Content-Type": "application/json",
        },
      }
    ).then((response) => {
      console.log("Log successful:", response.data);
    }).catch((error) => {
       console.error("Log failed:", error.response?.data || error.message);
    })

    
 
   
  
};
